import cs from 'classnames';

import { injectIntl } from 'react-intl';
import { MainNavigationProps } from '../../types';
import NavMenu from '../NavMenu';
import { getScrollProps, StyledMainNavigation, StyledMainNavigationScroll } from './styles';

import { memo } from 'react';
import { useNavigationConfig } from '../../hooks/useNavigationConfig';
import { getFormattedName } from '../../utils/getFormattedName';

const MainNavigation = ({ intl, navConfig, isExpanded, onTransitionEnd }: MainNavigationProps) => {
  const { navigationConfig } = useNavigationConfig();

  return (
    <StyledMainNavigation
      data-testid="nav-main"
      className="navigation-transition-wrapper"
      onTransitionEnd={onTransitionEnd}
    >
      <StyledMainNavigationScroll {...getScrollProps({ isExpanded })}>
        {navConfig
          .filter(({ id }) => id && navigationConfig[id])
          .map(({ id, icon, linkPattern, subMenu, permissionsMap = [] }) => (
            <NavMenu
              menuId={id}
              key={id}
              intl={intl}
              iconType={icon}
              subMenu={subMenu}
              linkPattern={linkPattern}
              permissionsMap={permissionsMap}
              isCollapsed={!isExpanded}
              menuName={getFormattedName({
                intl,
                menuId: id,
                isExpanded,
                messageConfig: navigationConfig[id],
              })}
              classNames={{
                menuName: cs({
                  'expanded-state-menu': isExpanded,
                  'collapsed-state-menu': !isExpanded,
                }),
                routeItemName: cs({
                  'expanded-state-route-item': isExpanded,
                  'collapsed-state-route-item': !isExpanded,
                }),
              }}
            />
          ))}
      </StyledMainNavigationScroll>
    </StyledMainNavigation>
  );
};

export default injectIntl(memo(MainNavigation));
